// Помощник заметки живёт в общем пакете (@unia/task-ui) — один на Ассистентус
// и ГиперТаск. Здесь приложение говорит ему, куда ходить и как брать пропуск.
//
// 🪤 Пропуск — живой, с продлением (lib/authToken), а не зеркало из браузера:
// зеркало отстаёт от входа и бывает пустым сразу после него.

import { configureNoteAssistant } from '@unia/task-ui';
import { getApiUrl } from './assistentusApi';
import { authHeader, getFreshAccessToken } from './authToken';

configureNoteAssistant({
    apiUrl: getApiUrl,
    authHeader: () => authHeader(),
    accessToken: () => getFreshAccessToken(),
    voiceBucket: () => {
        try { return localStorage.getItem('supabase_user_id'); } catch { return null; }
    },
});
